/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.shareModule')
  .controller(
    'ShareController',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    ['$scope', '$timeout', 'BulbShareService', 'PERMISSIONS', 'SHARE', ShareController],
  );

/**
 * Controller for share dialog.
 */
function ShareController($scope, $timeout, BulbShareService, PERMISSIONS, SHARE) {
  this.SHARE = SHARE;

  this.shareLinkToDisplay = function shareLinkToDisplay() {
    return window.location.href;
  };

  /**
   * Handling the share for Enter(13)/Space(32)/Click events as per WCAG guidelines.
   * @param event The Event triggered.
   * @param destination the destination where the profile should be shared like FB, Google etc.
   */
  this.share = function share(event, destination) {
    if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
      BulbShareService.share(this.unit, destination);
      if ($scope.$close) {
        $scope.$close();
      }
    }
  };

  /**
   * This method is used to copy the sharable link.
   */
  this.copyShareableLink = function copyShareableLink() {
    const $copyText = $('.bulb-copy-text-share-modal');
    $copyText.addClass('bulb-show-copied-text');
    const $copyStudentCodeButton = $('.bulb-share-copy-button');
    $copyStudentCodeButton.focus();
    $timeout(() => {
      $copyText.removeClass('bulb-show-copied-text');
    }, PERMISSIONS.COPY.COPY_TIMEOUT);

    const shareLink = $('#shareLink')[0];
    navigator.clipboard.writeText(shareLink.value);
  };

  /**
   * This function is used to share contents to Google Classroom.
   * It will share the private link.
   * A new pop Up window will be opened  which will redirect to Google Classroom for sharing the page.
   * Share toGoogle Classroom will be executed for Enter(13)/Space(32)/Click events as per WCAG guidelines.
   * @param event The Event triggered.
   * @param destination - google classroom.
   */
  this.shareToGoogleClassRoom = function shareToGoogleClassRoom(event, destination) {
    if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
      BulbShareService.shareToGoogleClassRoom(this.unit, destination);
      if ($scope.$close) {
        $scope.$close();
      }
    }
  };
}
